import { FormWithStyles, FormSubmission } from "../../../../content/blog/from-stateful-to-stateless-my-approach-to-building-form/previews/login-forms.jsx";
import * as React from 'react';
export default {
  FormWithStyles,
  FormSubmission,
  React
};